import SendEmail from "../components/SendEmail"

const SendEmails = () => {
    return <SendEmail/>
}

export default SendEmails